import React from "react";
import Register from "./Register";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { GoArrowLeft } from "react-icons/go";
import { getDeviceInfo } from "../utils/deviceInfo";

const AuthSelect = () => {
  const deviceInfo = getDeviceInfo();
  const location = useLocation();
  const info = location?.state;
  const navigate = useNavigate();
  const axiosInstance = useAuthAxios();
  const sendOtp = () => {
    axiosInstance
      .post(API.login, {
        email: info.email,
        password: info.password,
        "2faMethod": "email",
        deviceInfo: {
          name: deviceInfo.deviceName,
          uniqueId: deviceInfo.uniqueId,
          os: deviceInfo.operatingSystem?.family,
        },
      })
      .then((r: any) => {})
      .catch((e: any) => {
        console.log(e);
      });
  };
  return (
    <div className="w-full mds:w-4/5 md:w-3/5 xxxl:w-[50%] px-6 lgss:px-0 pt-28 pb-20 lgss:pt-16 font-manrope h-full mx-auto flex-col justify-between  items-center  flex">
      <div className="flex flex-col justify-center  items-center   w-full">
        <div className="flex justify-start items-start w-full px-4 lgss:px-8">
          <GoArrowLeft
            onClick={() => {
              navigate("/login");
            }}
            className="text-[#13181B] dark:text-gray-300 cursor-pointer text-[20px]"
          />
        </div>

        <h2 className="text-text_black w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 dark:text-gray-200  font-sora text-2xl text-center font-bold mt-16 lgss:mt-24 lgss:pt-0 ">
          Select Authentication Method
        </h2>
        {info.authApp === true && (
          <div
            className="w-full mt-16  lgss:px-12 xxxl:px-24 cursor-pointer"
            onClick={() =>
              navigate("/2fa-auth-app", {
                state: {
                  email: info.email,
                  from: info.from,
                  password: info.password,
                  authApp: info.authApp,
                  emailAuth: info.emailAuth,
                },
              })
            }
          >
            <div className="w-full flex justify-between items-center">
              <div className="w-4/5 md:w-3/5">
                <h4 className="text-text_black dark:text-white font-sora text-[16px] font-semibold pt-4 lgss:pt-0">
                  Google Authenticator
                </h4>
                <h4 className="text-[#617889] mt-1 dark:text-gray-300 font-manrope text-[13px] font-semibold pt-4 lgss:pt-0">
                  Send a one time password (OTP) to your google authenticator
                  app
                </h4>
              </div>
              <BsArrowRight className="text-2xl text-paragraph dark:text-white" />
            </div>
            <div className="rounded-full w-full h-[1px] bg-[#AEBCC6] dark:bg-gray-500 mt-4" />
          </div>
        )}
        {info.emailAuth === true && (
          <div
            className="w-full mt-16  lgss:px-12 xxxl:px-24  cursor-pointer"
            onClick={() => {
              sendOtp();
              navigate("/2fa-auth", {
                state: {
                  email: info.email,
                  from: info.from,
                  password: info.password,
                  authApp: info.authApp,
                  emailAuth: info.emailAuth,
                },
              });
            }}
          >
            <div className="w-full flex justify-between items-center">
              <div className="w-4/5 md:w-3/5">
                <h4 className="text-text_black dark:text-white font-sora text-[16px] font-semibold pt-4 lgss:pt-0">
                  Email
                </h4>
                <h4 className="text-[#617889] mt-1 dark:text-gray-300 font-manrope text-[13px] font-semibold pt-4 lgss:pt-0">
                  Send a one time password (OTP) to your email {info.email}.
                </h4>
              </div>
              <BsArrowRight className="text-2xl text-paragraph dark:text-white" />
            </div>
            <div className="rounded-full w-full h-[1px] bg-[#AEBCC6] dark:bg-gray-500 mt-4" />
          </div>
        )}
      </div>
    </div>
  );
};

const AuthSelectPage = () => (
  <div className="lgss:flex lgss:flex-row h-screen dark:bg-[#13181B]">
    <Register />
    <AuthSelect />
  </div>
);

export default AuthSelectPage;
